const zhCN = { 
  changeAvatar: '修改头像',
  chooseImageBtn: '选择图片',
  saveBtn: '保存',
  uploadSuccess: '上传成功！'
}
const enUS = {
  changeAvatar: 'Change Avatar',
  chooseImageBtn: 'Choose',
  saveBtn: 'Save',
  uploadSuccess: 'Upload successfully'
}

export default { zhCN, enUS }